/**
 * EmailBulkToolbar — shown when selectedIds.length > 0.
 * Reads selectedIds from store and dispatches PATCH /emails/bulk/update.json.
 */

import { h } from 'preact'

export function EmailBulkToolbar({ store, i18n }) {
  const count = store.selectionCount.value
  const selectedIds = store.selectedIds.value
  const emailTags = store.emailTags.value

  async function bulk(action, extra = {}) {
    await store.bulkUpdate(selectedIds, action, extra)
  }

  return (
    <div class="email-bulk-toolbar d-flex align-items-center gap-1 px-2 py-1 bg-primary-subtle border-bottom">

      {/* Selection count + clear */}
      <div class="d-flex align-items-center gap-2 me-2">
        <button
          class="btn btn-sm btn-link text-primary p-0"
          title={i18n?.t('helpers.actions.cancel')}
          onClick={store.clearSelection}
        >
          <i class="bi bi-x-lg" />
        </button>
        <span class="small fw-semibold text-primary">{count}</span>
      </div>

      {/* Bulk actions */}
      <button
        class="btn btn-sm btn-outline-secondary"
        title={i18n?.t('emails.mark_read')}
        onClick={() => bulk('read')}
      >
        <i class="bi bi-envelope-open" />
      </button>

      <button
        class="btn btn-sm btn-outline-secondary"
        title={i18n?.t('emails.mark_unread')}
        onClick={() => bulk('unread')}
      >
        <i class="bi bi-envelope" />
      </button>

      <button
        class="btn btn-sm btn-outline-secondary"
        title={i18n?.t('emails.archive')}
        onClick={() => bulk('archive')}
      >
        <i class="bi bi-archive" />
      </button>

      <button
        class="btn btn-sm btn-outline-secondary"
        title={i18n?.t('emails.trash')}
        onClick={() => bulk('trash')}
      >
        <i class="bi bi-trash" />
      </button>

      <button
        class="btn btn-sm btn-outline-warning"
        title={i18n?.t('emails.star')}
        onClick={() => bulk('star')}
      >
        <i class="bi bi-star" />
      </button>

      {/* Tag add/remove dropdown */}
      {emailTags.length > 0 && (
        <div class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" data-bs-strategy="fixed">
            <i class="bi bi-tag" />
          </button>
          <div class="dropdown-menu shadow-sm p-2" style="min-width:200px">
            <div class="small text-muted fw-semibold mb-1 px-2">{i18n?.t('emails.add_tag')}</div>
            {emailTags.map(tag => (
              <button
                key={tag.id}
                class="dropdown-item small d-flex align-items-center gap-2"
                onClick={() => bulk('tag_add', { tag_id: tag.id })}
              >
                <span class="badge rounded-pill" style={{ backgroundColor: tag.color || '#6c757d', fontSize: '0.7rem' }}>
                  {tag.tag}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Select all */}
      <button
        class="btn btn-sm btn-link text-primary p-0 ms-auto"
        onClick={() => store.selectAll(store.emails.value.map(e => e.id))}
      >
        {i18n?.t('emails.select_all')}
      </button>

    </div>
  )
}
